export const enum NotificationsActionTypes {
    SET_TAMPER_NOTIFICATIONS = 'SET_TAMPER_NOTIFICATIONS',
    UPDATE_TAMPER_NOTIFICATION = 'UPDATE_TAMPER_NOTIFICATION',
    REMOVE_TAMPER_NOTIFICATION = 'REMOVE_TAMPER_NOTIFICATION',
    SET_EMOB_FIRMWARE_NOTIFICATION = 'SET_EMOB_FIRMWARE_NOTIFICATION',
    DISMISS_APP_PROMO_COMFORT_BANNER = 'DISMISS_APP_PROMO_COMFORT_BANNER',
    SHOW_GLOBAL_PROMPT = 'SHOW_GLOBAL_PROMPT',
    HIDE_GLOBAL_PROMPT = 'HIDE_GLOBAL_PROMPT',
}
